// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://jxttnpucqqkiyqwzeleo.supabase.co'
export const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp4dHRucHVjcXFraXlxd3plbGVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0NjQ0ODQsImV4cCI6MjA3MDA0MDQ4NH0.wEtVJAKjstyLbcCf0NgIak7aL2hhk0XDmfh3gDOBeA0'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'supabase.auth.token',
    storage: window.localStorage,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js/2.45.0',
      'apikey': supabaseAnonKey
    }
  },
  db: {
    schema: 'public'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})

// Verify connection on load
supabase.auth.getSession()
  .then(({ error }) => {
    if (error) {
      console.error('Supabase connection error:', error.message)
    }
  })
  .catch(err => {
    console.error('Failed to connect to Supabase:', err.message)
  })
